export const RISK_CELL_HEIGHT = 58;
export const RISK_CELL_PADDING_X = 14;
export const RISK_CELL_PADDING_Y = 10;
export const RISK_LABEL_FONT_SIZE = 11;
export const RISK_VALUE_FONT_SIZE = 19;
export const RISK_DATE_FONT_SIZE = 15;
export const RISK_STRIPE_WIDTH = 3;
export const RISK_LABEL_LETTER_SPACING = 0.7;
